import { styled as m, Box as a } from "@mui/material";
import f from "next/link";
import * as p from "ramda-adjunct";
import { jsx as o } from "react/jsx-runtime";
const l = m(f)`
  text-decoration-skip-ink: none;
  text-underline-offset: 2px;
`, u = (i) => {
  const {
    href: t,
    children: e,
    className: r,
    target: n,
    as: x,
    ...s
  } = i;
  return p.isNilOrEmpty(t) ? /* @__PURE__ */ o(a, {
    className: r,
    children: e
  }) : /* @__PURE__ */ o(l, {
    className: r,
    ...s,
    href: t,
    target: n,
    children: e
  });
};
export {
  u as default
};
//# sourceMappingURL=NextLink.js.map
